import React, { useState } from "react";
import { IconClose } from "../../../components/Ui/Icon";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import { toast } from "react-toastify";
import { sendEmailToUsers } from "../../../services/email";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles

const CreateEmailMKT = ({ togglePopup, onSubmited, data }) => {
  console.log("data", data);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    title: "",
    html: "",
    userType: "unpaid", // Default user type
    ...data,
  });

  const USER_TYPE = [
    {
      id: "paid",
      value: "Paid User",
    },
    {
      id: "unpaid",
      value: "Unpaid User",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((preValue) => ({
      ...preValue,
      [name]: value,
    }));
  };

  const handleHtmlChange = (value) => {
    setFormValue((preValue) => ({
      ...preValue,
      html: value,
    }));
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const callAPI = async () => {
      setLoading(true);
      try {
        await sendEmailToUsers(formValue);
        setTimeout(() => {
          setLoading(false);
        });
        toast.success("Successfully");
        togglePopup();
        onSubmited();
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full">
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between p-2 md:p-3 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white">
                Create
              </h3>
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={togglePopup}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="space-y-4">
              <div className="flex flex-col md:flex-row w-full">
                <div className="w-full p-4 overflow-x-auto shadow-md shadow-slate-300">
                  <form
                    onSubmit={onSubmitHandler}
                    className="grid gap-2 sm:grid-cols-2 sm:gap-4 [&_input]:outline-none [&_textarea]:outline-none"
                  >
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        name="title"
                        value={formValue.title}
                        onChange={handleChange}
                        placeholder="Title"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>

                    <div className="sm:col-span-1">
                      <label
                        htmlFor="userType"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Send To:
                      </label>
                      <select
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="userType"
                        defaultValue={formValue.userType}
                        onChange={(e) =>
                          setFormValue((preValue) => ({
                            ...preValue,
                            userType: e.target.value,
                          }))
                        }
                      >
                        {USER_TYPE.map((u) => (
                          <option value={u.id} key={u.id}>
                            {u.value}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* HTML Editor Field */}
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="html"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        HTML Content
                      </label>
                      <ReactQuill
                        theme="snow"
                        modules={{
                          toolbar: [
                            ["bold", "italic", "underline", "strike"], // toggled buttons
                            [{ align: [] }],
                            [{ color: [] }, { background: [] }],
                            ["blockquote", "code-block"],
                            ["link", "image", "video"],
                            [
                              { list: "ordered" },
                              { list: "bullet" },
                              { list: "check" },
                            ],
                            // [{ script: "sub" }, { script: "super" }], // superscript/subscript
                            // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                            // [{ direction: "rtl" }], // text direction

                            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            // dropdown with defaults from theme
                            // [{ font: [] }],

                            ["clean"],
                          ],
                        }}
                        value={formValue.html}
                        onChange={handleHtmlChange}
                        className="bg-white dark:bg-gray-700 mb-5"
                      />
                    </div>
                    {!data && (
                      <div className="flex justify-center sm:col-span-2">
                        <button
                          disabled={loading}
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEmailMKT;
